import React from 'react';
import { PhoneOutgoing, ListTodo } from 'lucide-react';
import { useContact } from '../../context/ContactContext';
import OutboundDialer from './OutboundDialer';

// Incident 2026-09-14 fix 1: an accepted scheduled-callback TASK used to
// render exactly like a live voice call (timer, escalation card) with no way
// to dial the customer — the only dialer (OutboundDialer, Andrew J 13 Sep)
// lived on the idle Waiting screen, which unmounts the moment any contact
// connects. This card sits at the top of the centre panel for TASK contacts
// only: it says plainly that nobody is on the line, and surfaces the SAME
// OutboundDialer pre-filled from the task's own attributes (callerNumber,
// tenantId, callbackId, originalContactId — the D8 dial context).
export default function CallbackTaskCard() {
  const { display, voiceActive } = useContact();
  if (!display || display.meta?.channel !== 'TASK') return null;

  const cb = display.callback ?? {};
  const number = cb.callerNumber || (display.customer?.phone && display.customer.phone !== '—' ? display.customer.phone : '');
  const tenantId = display.tenantId || null;

  return (
    <div className="task-card">
      <div className="task-card-head">
        <span className="task-card-icon"><ListTodo size={13} /></span>
        <span className="task-card-title">Scheduled callback task</span>
        {display.callbackWindow && <span className="task-card-window">{display.callbackWindow}</span>}
      </div>
      <p className="task-card-copy">
        <strong>The customer is not on the line.</strong> This task is the reminder to call them
        back{number ? <> on <strong>{number}</strong></> : null}. The context below is from the call
        that booked it.
        {voiceActive && ' Finish the current voice call before dialling.'}
      </p>
      <OutboundDialer
        initialNumber={number}
        initialTenantId={tenantId}
        dialContext={{
          tenantId,
          brandName: display.brandName ?? null,
          callbackId: cb.callbackId ?? null,
          originalContactId: cb.originalContactId ?? null,
          // #20 (2026-09-23): the task's own handover context, so the voice leg
          // that follows can show what this call is for (lib/callbackOrigin).
          handover: {
            aiSummary: display.aiSummary ?? null,
            reason: display.escalation?.reason ?? null,
            window: display.callbackWindow ?? null,
            callerNumber: number || null,
            taskContactId: display.meta?.contactId ?? null,
          },
        }}
        title="Call the customer for this callback"
        submitLabel="Call customer"
        icon={PhoneOutgoing}
      />
    </div>
  );
}
